import React from 'react';

import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { ReactComponent as AgreementsIcon } from '../../../assets/icons/agreements/agreements.svg';
import { ReactComponent as CookiesIcon } from '../../../assets/icons/agreements/cookies.svg';
import { ReactComponent as SecurityIcon } from '../../../assets/icons/security.svg';
import { AgreementType } from '../../../redux/api/agreements/interfaces';
import { useLeadBlockStyles } from './AgreementsLeadBlock.styles';

const AGREEMENT_LEAD_ICONS: Record<
  AgreementType,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  [AgreementType.COOKIE_POLICY]: CookiesIcon,
  [AgreementType.PRIVACY_POLICY]: SecurityIcon,
  [AgreementType.TERMS_OF_USE]: AgreementsIcon,
};

interface IAgreementsLeadBlockProps {
  title: string;
  paragraph?: string | null;
  agreementType: AgreementType;
  titleEndAdornment?: React.ReactNode;
}

const AgreementsLeadBlock = ({
  title,
  paragraph,
  agreementType,
  titleEndAdornment,
}: IAgreementsLeadBlockProps) => {
  const theme = useTheme();
  const { classes } = useLeadBlockStyles(theme);
  const LeadIcon = AGREEMENT_LEAD_ICONS[agreementType];

  return (
    <div className={classes.root}>
      <div className={classes.titleRow}>
        <Typography variant="h2" component="h2" className={classes.title}>
          {title}
        </Typography>
        {titleEndAdornment ? (
          <span className={classes.titleEnd}>{titleEndAdornment}</span>
        ) : null}
      </div>
      {paragraph ? (
        <div className={classes.paragraphRow}>
          <div className={classes.iconWrap}>
            <LeadIcon className={classes.icon} aria-hidden />
          </div>
          <Typography
            variant="body1"
            color="text.secondary"
            className={classes.paragraph}
            sx={{ whiteSpace: 'pre-wrap' }}>
            {paragraph}
          </Typography>
        </div>
      ) : null}
    </div>
  );
};

export default AgreementsLeadBlock;
